import { useMutation } from "@tanstack/react-query";
import { putApiUsers } from "Infrastructure/Api/Api";
import { HttpStatusCode } from "Infrastructure/Models/HttpStatusCodes";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export function useUserUpdateMutation() {
	const showSnackbar = useSnackbar();
	const { t } = useResource();

	const mutation = useMutation({
		mutationFn: putApiUsers,
		onSuccess: (data) => {
			if (data.status === HttpStatusCode.Ok) {
				showSnackbar("Uživatel úspěšně aktualizován.", "success");
			} else {
				showSnackbar(t(Resources.Errors.Error500), "error");
			}
		},
	});

	return mutation;
}
